import React, { Component } from 'react';

import Note1 from '../assets/images/tiltednote.svg';

import Notes from '../assets/images/notes.svg';

import bsulogo from '../assets/images/bsu-logo.svg';
import {Link} from 'react-router-dom';
import ReactGA from 'react-ga';

class End extends Component {

  clickEvent(label){
    if(label == "New Song"){
      ReactGA.event({
        category: "end",
        action: "click",
        label: label,
        value: this.props.songId,
      });
      if(this.props.isReplay){
        ReactGA.event({
          category: "end",
          action: "click",
          label: label,
          value: this.props.songId,
        });
      }
    }
    else{
      ReactGA.event({
        category: "end",
        action: "click",
        label: label,
      });
      if(this.props.isReplay){
        ReactGA.event({
          category: "end",
          action: "click",
          label: label,
        });
      }
    }
  }

  render() {
    return (
      <section className="end-container">
        <header>
          <div className="title">
        <img className="first-note" src={Note1} alt=""/>

          <h1 className="page-title">Your Score</h1>
          <img className="second-note" src={Notes} alt=""/>
          </div>

          <h2 className="final-score">
            <div className="score-container">
              <div>

                <h6>SCORE: <p>{this.props.finalScore}</p></h6>
              </div>
              <div>
                <h6>ACCURACY: <p>{this.props.finalScorePercentage}%</p></h6>
              </div>
              </div>




          </h2>
        </header>
           <Link className="button-primary"
                 to="/songs"
                 onClick={() => {
                   this.props.setReplay();
                     this.clickEvent("New Song")
                 }}
           >New Song</Link>
          <article>
            <a className="ben" href='http://cms.bsu.edu/' target="_blank" onClick={() => {this.clickEvent("Ball state link")}}> <img src={bsulogo} alt="Ball State University We Fly"/></a>
           <p>Tap to the Top was created in Partnership with <a href='http://cms.bsu.edu/' target="_blank" onClick={() => {this.clickEvent("Ball state logo")}}>Ball State University</a> and the <a href='http://cms.bsu.edu/about/administrativeoffices/digital-corps' target="_blank" onClick={() => {this.clickEvent("Digital corps link")}}>Digital Corps</a>. All tap dance recordings were performed by Kelsey Krigas, a <a href='http://cms.bsu.edu/academics/collegesanddepartments/theatredance' target="_blank" onClick={() => {this.clickEvent("Musical theatre link")}}>Musical Theatre</a> major at Ball State. Original game concept by Dara Metcalfe. All rights reserved 2018.</p>
          </article>


      </section>
    );
  }
}

export default End;



// WEBPACK FOOTER //
// ./src/components/End.js